import { render, staticRenderFns } from "./FacebookApiHistories.vue?vue&type=template&id=0b694f95&scoped=true"
import script from "./FacebookApiHistories.vue?vue&type=script&lang=js"
export * from "./FacebookApiHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b694f95",
  null
  
)

export default component.exports